export const WELL_TYPE_SINGLE = "WELL_TYPE_SINGLE"
export const WELL_TYPE_SEQUENCE = "WELL_TYPE_SEQUENCE"

export const WELL_PLACEMENT_CENTER = "center"
export const WELL_PLACEMENT_TOP = "top"
export const WELL_PLACEMENT_BOTTOM = "bottom"
